import React from 'react';
import { Chip as BaseChip } from '../common/Chip';

export const Chip: React.FC<React.ComponentProps<typeof BaseChip> & { status: string }> = ({
  status,
  ...rest
}) => {
  const normalised = status.toLowerCase();
  const color = normalised.startsWith('active')
    ? 'success'
    : normalised.startsWith('canceled')
    ? 'error'
    : normalised.startsWith('altering')
    ? 'info'
    : 'default';

  return <BaseChip variant='outlined' size='small' {...rest} color={color} label={status} />;
};
